import { render, staticRenderFns } from "./ExtensionFooter.vue?vue&type=template&id=6093e131&scoped=true&"
import script from "./ExtensionFooter.vue?vue&type=script&lang=js&"
export * from "./ExtensionFooter.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionFooter.vue?vue&type=style&index=0&id=6093e131&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6093e131",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
